<template>
  <div class="player-area">
    <div class="outer-wrapper">
      <div class="player-bg" aria-hidden="true" :style="`background-image: url(${convertBlurImage(posterImage)}`">플레이어 배경 영역</div>
      <div class="inner-wrapper">
        <div class="player" id="player">
          <div class="player-bg" aria-hidden="true" :style="`background-image: url(${convertBlurImage(posterImage)}`">플레이어 배경 영역</div>
          <div class="picture-area">
            <WebpImage :image-info="{imageUrl: posterImage, width: isHorizontal ? 540 : 202, height: 302, alt: contentInfo.title, className: `player-image ${currentSection}`}" />
          </div>
          <div @click.prevent="clickPlayer" class="btn-play"><player class="play-btn"></player></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Meta from '@/components/meta/Meta'
import Player from '@/assets/svg/common/ic-player-play-l.svg'
import _ from 'lodash'
import { ATTR_BY_PLAYER_TYPE } from '@/common/player.const'
import { resizeThumbnail } from '@/common/image.filter'
import WebpImage from '@/components/image/WebpImage'

/**
 * 기존 모바일웹에서 사용하는 플레이어 영역 Component
 * 재생 시 App 실행
 * 차후 이 Component만 갈아끼기 위해 Apollo쪽과 형태를 맞춤
 */
export default {
  mixins: [Meta],
  name: 'GoAppPlayer',
  data () {
    return {
      isHorizontal: false
    }
  },
  metaInfo () {
    return {
      title: this.metaTitle,
      titleTemplate: '%s : 웨이브'
    }
  },
  props: {
    contentInfo: {
      type: Object
    },
    currentSection: {
      type: String
    },
    clickPlayer: {
      type: Function
    },
    goBack: {
      type: Function
    }
  },
  components: {
    WebpImage,
    Player
  },
  computed: {
    metaTitle () {
      return _.get(this.contentInfo, ATTR_BY_PLAYER_TYPE[this.currentSection].title, '프로그램 상세화면')
    },
    posterImage () {
      // poster image 우선순위 mo-)  1. 로고 포함된 시즌(무비 그룹) 가로 포스터 / 2. 로고가 포함된 시즌(무비 그룹) 세로 포스터
      const {
        season_horizontal_logoY_image: horizonPosterVOD = '',
        season_vertical_logoY_image: verticalPosterVOD = '',
        moviegroup_horizontal_logoY_image: horizonPosterMovie = '',
        moviegroup_vertical_logoY_image: verticalPosterMovie = ''
      } = this.contentInfo

      const { seasonposterimage: alternativePosterVOD = '' } = this.contentInfo
      const isMovie = (this.currentSection === 'movie')
      const posterMovie = horizonPosterMovie || verticalPosterMovie
      const posterVOD = horizonPosterVOD || verticalPosterVOD || alternativePosterVOD

      return isMovie ? posterMovie : posterVOD
    }
  },
  created () {
    this.getPosterType()
  },
  methods: {
    convertBlurImage (image) {
      return resizeThumbnail(image, { width: 124, height: 72, option: 'b20', quality: 10 })
    },
    getPosterType () {
      const { season_horizontal_logoY_image: horizonPosterVOD = '', moviegroup_horizontal_logoY_image: horizonPosterMovie = '' } = this.contentInfo
      this.isHorizontal = (horizonPosterVOD + horizonPosterMovie).length > 0
    }
  }
}
</script>
